import { GzPolicyUiSettingsGridItemFormWebComponent } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/form';
import { html, TemplateResult } from 'lit';
import { translateFn } from '../../../../../../../utils/translator.helper';
import { customElement, query } from 'lit/decorators.js';
import { GzFormFieldWebComponent } from '../../../../../../../ui/gzForm/formField';
import { GzInputWebComponent } from '../../../../../../../ui/gzInput/component/GzInputWebComponent';
import { FormGroup } from '../../../../../../../ui/gzForm/formGroup/form-group';
import { WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_ACCCESS_UNIX_PATHS_ITEM } from '../../../../../../../webcomponents.constants';
import { pathValidators } from './utils/validators';

@customElement(WEB_COMPONENT_POLICY_PANEL_ANTIMALWARE_ON_ACCCESS_UNIX_PATHS_ITEM)
export class GzAntimalwareOnAccessUnixPathsItemFormWebComponent extends GzPolicyUiSettingsGridItemFormWebComponent {
  @query('#itemPath')
  itemPath: GzFormFieldWebComponent<GzInputWebComponent, string>;

  public setError(error: string) {
    this.itemPath.setError(error);
  }

  renderFormFields(): TemplateResult {
    return html`
      <div class="policy-grid-item-form--field">
        <gz-form-field id="itemPath" label="${translateFn('Add directory')}">
          <gz-input gz-form-input placeholder="${translateFn('Enter directory path')}" style="width: 370px;"></gz-input>
        </gz-form-field>
      </div>
    `;
  }

  focusFirstInput(): void {
    this.itemPath.Input.inputFocus();
  }

  createFormGroup(): void {
    this.itemPath.Validators = pathValidators();

    this.formGroup = new FormGroup({
      path: this.itemPath,
    });
  }

  resetForm(): void {
    this.itemPath.value = '';
    this.itemPath.resetField();
  }

  reset() {
    this.resetForm();
  }

  resetOnAdd() {
    this.resetForm();
  }
}
